export default "__VITE_ASSET__B8b$hgXV__"